class Adcount {
    constructor(adInfo) {
        this.init(adInfo);
    }

    init(adInfo) {
        this.initParams(adInfo);
        this.initFlag(adInfo);
    }

    initParams(adInfo) {
        if (adInfo.code === 1 && Array.isArray(adInfo.info) && adInfo.info.length) {
            this.ads = this.classify(adInfo.info);
            this.preAds = this.ads[1]; // 前贴片，包含广告、片头
            this.pauseAds = this.ads[3];
            this.cornerAds = this.ads[4];
            this.bannerAds = this.ads[5];
            this.behindAds = this.ads[9];
        }
    }

    initFlag(adInfo) {
        if (adInfo.code === 1 && adInfo.info.length !== 0) {
            this.preFlag = this.getFlag(this.preAds, 1);
            this.pauseFlag = this.getFlag(this.pauseAds, 3);
            this.cornerFlag = this.getFlag(this.cornerAds, 4);
            this.bannerFlag = this.getFlag(this.bannerAds, 5);
            this.behindFlag = this.getFlag(this.bannerAds, 9);
        }
    }

    classify(arr) {
        const preAds = [];
        const pauseAds = [];
        const cornerAds = [];
        const bannerAds = [];
        const behindAds = [];

        if (arr.length === 0) return {};

        for (const item of arr) {
            switch (item.type) {
                case 1:
                case 2:
                    preAds.push(item);
                    break;
                case 3:
                    pauseAds.push(item);
                    break;
                case 4:
                    cornerAds.push(item);
                    break;
                case 5:
                    bannerAds.push(item);
                    break;
                case 9:
                    behindAds.push(item);
                    break;
                default:
                    preAds.push(item);
                    break;
            }
        }

        return {
            1: preAds,
            3: pauseAds,
            4: cornerAds,
            5: bannerAds,
            9: behindAds,
        };
    }

    getFlag(arr, type) {
        const obj = {};

        for (let i = 0, len = arr.length; i < len; i++) {
            const item = arr[i];

            if (type === item.type) {
                const start = item.eventlog.start || [];
                const middle = item.eventlog.middle || [];
                const end = item.eventlog.end || [];
                const tempArr = start.concat(middle, end);

                for (let j = 0, tLen = tempArr.length; j < tLen; j++) {
                    obj[tempArr[j]] = false;
                }
            }
        }

        return obj;
    }

    // type : 1-广告和片头，2-暂停广告，3-角标, index : 各类型广告索引, time : 2\3类型广告不传
    send(type, index, time) {
        let curLog = [];
        let marcoLog = null;
        let curFlag = {};

        switch (type) {
            case 1:
                curLog = this.getCurrentLog(this.preAds, index, time);
                marcoLog = this.getMacroLog(this.preAds, index, time);
                curFlag = this.preFlag;
                break;
            case 3:
                curLog = this.pauseAds[index].eventlog.start || []; //   暂停、角标广告只有start
                curFlag = this.pauseFlag;
                break;
            case 4:
                curLog = this.cornerAds[index].eventlog.start || [];
                curFlag = this.cornerFlag;
                break;
            case 5:
                curLog = this.bannerAds[index].eventlog.start || [];
                curFlag = this.bannerFlag;
                break;
            case 9:
                curLog = this.getCurrentLog(this.behindAds, index, time);
                marcoLog = this.getMacroLog(this.behindAds, index, time);
                curFlag = this.behindFlag;
                break;
            default:
                break;
        }

        if (!marcoLog) {
            marcoLog = curLog;
        }

        if (curLog.length === 0) {
            return;
        }

        curLog.forEach((flagKey, index) => {
            const postItem = marcoLog[index];

            if (!curFlag[flagKey]) {
                // 对已发曝光监测做标记，避免重发
                curFlag[flagKey] = true;
                this.postLog(postItem);
            }
        });

        for (const log in curFlag) {
            if (log !== curLog[0]) {
                if (!curFlag[log]) {
                    // 对之前漏发的曝光监测补发并做标记，避免遗漏
                    curFlag[log] = true;

                    const index = curLog.findIndex(log);
                    const postItem = marcoLog[index];

                    if (postItem) {
                        this.postLog(postItem);
                    }
                }
            } else {
                break;
            }
        }
    }

    getMacroLog(ads, index, time) {
        const diffTime = Math.ceil(time);
        const current = ads[index];
        const currentDuration = Math.ceil(current.duration);
        let cLog = [];

        switch (diffTime) {
            case 1:
                cLog = this.sendMarcoReplace(current.eventlog.start, Math.floor(time));
                break;
            case Math.ceil(currentDuration / 2):
                cLog = this.sendMarcoReplace(current.eventlog.middle, Math.round(time));
                break;
            case currentDuration:
                cLog = this.sendMarcoReplace(current.eventlog.end, Math.ceil(time));
                break;
        }

        return cLog;
    }

    getCurrentLog(ads, index, time) {
        const diffTime = Math.ceil(time);
        const current = ads[index];
        const currentDuration = Math.ceil(current.duration);
        let cLog = [];

        switch (diffTime) {
            case 1:
                cLog = current.eventlog.start || [];
                break;
            case Math.ceil(currentDuration / 2):
                cLog = current.eventlog.middle || [];
                break;
            case currentDuration:
                cLog = current.eventlog.end || [];
                break;
        }

        return cLog;
    }

    sendMarcoReplace(starData, time) {
        let list = Array.isArray(starData) ? [...starData] : [];

        list = list.map((url) =>
            url.replace('__ADSIZE_TYPE__', 0).replace('__VIDEO_DURATION__', time).replace('__VIDEO_TIME__', time),
        );

        return list;
    }

    // 参数参见send接口说明
    sendClick(type, index, clickData, actionId, clickTime = 0) {
        let curLog = [];
        const soundsClick = actionId === '5' || actionId === '6';

        switch (type) {
            case 1:
                curLog = this.clickMarcoReplace(
                    this.preAds[index].eventlog.clickTrack,
                    this.preAds[index].eventlog.vopTrack,
                    clickData,
                    actionId,
                    soundsClick,
                    clickTime,
                );
                break;
            case 3:
                curLog = this.clickMarcoReplace(
                    this.pauseAds[index].eventlog.clickTrack,
                    this.pauseAds[index].eventlog.vopTrack,
                    clickData,
                    actionId,
                    soundsClick,
                    clickTime,
                );
                break;
            case 4:
                curLog = this.cornerAds[index].eventlog.clickTrack;
                break;
            case 5:
                curLog = this.bannerAds[index].eventlog.clickTrack;
                break;
            case 9:
                curLog = this.clickMarcoReplace(
                    this.behindAds[index].eventlog.clickTrack,
                    this.behindAds[index].eventlog.vopTrack,
                    clickData,
                    actionId,
                    soundsClick,
                    clickTime,
                );
                break;
            default:
                break;
        }

        for (const tmpLog of curLog) {
            this.postLog(tmpLog);
        }
    }

    clickMarcoReplace(clickTrack, vopTrack, clickData, actionId, soundsClick, clickTime) {
        let clickList = Array.isArray(clickTrack) ? [...clickTrack] : [];
        let vopList = Array.isArray(vopTrack) ? [...vopTrack] : [];
        let list = soundsClick ? vopList : [...clickList, ...vopList];

        if (clickData) {
            const { startTime, endTime, offsetX, offsetY, adSpaceWidth, adSpaceHeight } = clickData;

            list = list.map((url) =>
                url
                    .replace('__EVENT_TIME_START__', parseInt(startTime, 10))
                    .replace('__EVENT_TIME_END__', parseInt(endTime, 10))
                    .replace('__OFFSET_X__', parseInt(offsetX, 10))
                    .replace('__OFFSET_Y__', parseInt(offsetY, 10))
                    .replace('__ADSPACE_W__', parseInt(adSpaceWidth, 10))
                    .replace('__ADSPACE_H__', parseInt(adSpaceHeight, 10))
                    .replace('__VIDEO_ACTION_ID__', actionId)
                    .replace('__ADSIZE_TYPE__', 0)
                    .replace('__VIDEO_DURATION__', Math.round(clickTime))
                    .replace('__VIDEO_TIME__', Math.round(clickTime)),
            );
        }

        return list;
    }

    postLog(url) {
        const img = new Image();

        img.src = url;
    }
}

export default Adcount;
